import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { CheckCircle2, Circle, RotateCcw } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function ChecklistRunner({ playbook, onRun }) {
  const { t } = useTranslation();
  const [done, setDone] = useState([]);
  const items = playbook.checklist || [];
  const toggle = (i) => setDone((d) => (d.includes(i) ? d.filter((x) => x !== i) : [...d, i]));
  const complete = items.length > 0 && done.length === items.length;
  const log = async () => {
    const { data } = await api.post(`/playbooks/${playbook.id}/checks`, { checked: done });
    toast[data.complete ? "success" : "warning"](data.complete ? t("playbooks.checkGo") : t("playbooks.checkPartial", { n: data.checked, total: data.total }));
    setDone([]);
    onRun?.();
  };
  if (!items.length) return <p className="text-sm text-slate-500">{t("playbooks.noChecklist")}</p>;
  return (
    <div data-testid="playbook-checklist">
      <ul className="space-y-2">
        {items.map((c, i) => (
          <li key={i}>
            <button type="button" onClick={() => toggle(i)} data-testid={`playbook-check-item-${i}`}
              className={`w-full flex items-start gap-3 text-left rounded-lg border px-3 py-2.5 text-sm transition-colors ${done.includes(i) ? "border-emerald-300 bg-emerald-50 text-emerald-900" : "border-slate-200 hover:border-slate-300"}`}>
              {done.includes(i) ? <CheckCircle2 size={18} className="text-emerald-600 shrink-0 mt-0.5" /> : <Circle size={18} className="text-slate-300 shrink-0 mt-0.5" />}
              {c}
            </button>
          </li>
        ))}
      </ul>
      <div className="mt-3 flex items-center gap-3">
        <Button onClick={log} data-testid="playbook-check-log-btn" className={complete ? "bg-emerald-600 hover:bg-emerald-500 text-white" : "bg-slate-900 hover:bg-slate-800 text-white"}>
          {complete ? t("playbooks.checkReady") : t("playbooks.checkLog", { n: done.length, total: items.length })}
        </Button>
        {done.length > 0 && <button type="button" onClick={() => setDone([])} className="text-xs text-slate-500 inline-flex items-center gap-1"><RotateCcw size={12} />{t("playbooks.reset")}</button>}
      </div>
    </div>
  );
}
